import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['sidebar', 'fixedHeader', 'contentDiv', 'progressCard'];

  connect() {
    // Use requestAnimationFrame to ensure DOM is fully rendered
    requestAnimationFrame(() => {
      this.setSidebarHeight();
      this.syncWidths();
    });

    // Also sync on window resize
    window.addEventListener('resize', this.syncWidths.bind(this));

    // Watch for sidebar toggle (class changes on body or sidebar element)
    this.observeSidebarChanges();
  }

  disconnect() {
    window.removeEventListener('resize', this.syncWidths.bind(this));
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  setSidebarHeight() {
    const sidebar = this.sidebarTarget;
    const sidebarHeight = sidebar.offsetHeight;
    document.documentElement.style.setProperty('--sidebar-height', sidebarHeight + 'px');
  }

  syncWidths() {
    if (this.hasContentDivTarget && this.hasFixedHeaderTarget) {
      const contentDiv = this.contentDivTarget;
      const fixedHeader = this.fixedHeaderTarget;

      // Use requestAnimationFrame for smooth updates
      requestAnimationFrame(() => {
        // Get the computed width and position of the content div
        const contentRect = contentDiv.getBoundingClientRect();

        // Apply the same width and horizontal position to the fixed header
        fixedHeader.style.width = contentRect.width + 'px';
        fixedHeader.style.left = contentRect.left + 'px';
        fixedHeader.style.transform = 'none'; // Remove the centering transform

        // Also sync the progress card if it exists
        if (this.hasProgressCardTarget) {
          this.progressCardTarget.style.width = contentRect.width + 'px';
          this.progressCardTarget.style.left = contentRect.left + 'px';
        }
      });
    }
  }

  observeSidebarChanges() {
    let resizeTimeout;

    // Create observer to watch for class changes that might indicate sidebar toggle
    this.observer = new MutationObserver(() => {
      // Debounce the sync to avoid multiple rapid calls
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        this.syncWidths();
      }, 10);
    });

    // Observe changes on body and common sidebar elements
    this.observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'style'],
    });

    // Also observe the sidebar component if it exists
    const sidebarElement = document.querySelector('.adm-panel');
    if (sidebarElement) {
      this.observer.observe(sidebarElement, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class', 'style'],
      });
    }
  }
}
